module.exports = __webpack_public_path__ + "img/ai-img-video.7b72dbaf.jpg";